import { TIME } from "@bridgesplit/utils";

export const LOAN_REFINANCE_GRACE_BEFORE_DEFAULT = TIME.DAY * 2;
